import * as types from './mutation_types';

export default {
  [types.RESET](state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      items: [],
      message: "",
    });
  },

  [types.SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.SET_LOADING](state, isLoading) {
    Object.assign(state, {
      isLoading
    });
  },

  [types.SET_ITEMS](state, items) {
    Object.assign(state, {
      error: '',
      items,
    });
  },

  [types.SET_MESSAGE](state, message) {
    Object.assign(state, {
      message
    });
  },

  [types.TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },

  [types.ADD_MARKER](state, marker) {
    state.items.push(marker);
  },

  [types.UPDATE_MARKER](state, updatedMarker) {
    const index = state.items.findIndex(m => m.id === updatedMarker.id);
    if (index !== -1) {
      state.items.splice(index, 1, updatedMarker);
    }
  },

  [types.DELETE_MARKER](state, markerId) {
    state.items = state.items.filter(m => m.id !== markerId);
  },
};
